import React from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import AllocationsChart from './AllocationsChart';
import './SaveProgress.css'

library.add(faCircleNotch)

const SaveProgress = ({
  allStatuses,
  selectedModels,
  selectedNewModelNames,
  models
}) => {
  console.log('Selected New Model Names:', selectedNewModelNames);
  console.log('Models:', models);
  return (
    <div>
      <div className='saving-models'>Saving Models </div>
      <div className='model-container'>
        {selectedModels.map((selectedModel, index) => {
          const model = models.find(model => model.ticker === selectedModel)
          if (!model) {
            return null
          }

          const statusObj = allStatuses.find(status => status.name === model.name)
          let message

          if (statusObj === undefined) {
            message = ` ${selectedNewModelNames[index]} ` // Use the new name here
          } else if (statusObj.status === 200 || statusObj.status === 201) {
            // Don't render anything if status is 200 or 201
            return null
          } else {
            message = `${selectedNewModelNames[index]} - did not save due to a network error, please try again.` // Use the new name here
          }
          const allocationData = model.allocation.split('/').map(Number);
          return (
            <div key={index} className='model-status'>
              <div className='model-message'>{message}</div>
              <AllocationsChart className="AllocationsChart" data={allocationData} index={index} />
              {statusObj === undefined && (
                <div className='waiting'>
                  <div className='progress-saving-spinner'>
                    <FontAwesomeIcon
                      icon='circle-notch'
                      size='2x'
                      style={{ color: '#050139' }}
                      spin
                    />
                  </div>
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    allStatuses: state.data.allStatuses,
    selectedModels: state.data.selectedModels,
    selectedNewModelNames: state.data.selectedNewModelNames,
    models: state.data.models
  }
}

export default connect(mapStateToProps)(SaveProgress)